import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): unknown {
        // const cleaned = value.replace(/\D/g, '');
        let cleaned = value
        if(cleaned.indexOf('+*') != -1 ) {
            cleaned = cleaned.substring(2)
        }
        if(cleaned.indexOf('+1') != -1 ) {
            cleaned = cleaned.substring(2)
        }
        if(!cleaned.includes('***')) {
            cleaned = cleaned.replace(/\D/g, '');
        }

        let formatted = '';

        if (cleaned.length > 0) {
            formatted = `(${cleaned.substring(0, 3)}`;
            if (cleaned.length >= 4) {
                formatted += `) ${cleaned.substring(3, 6)}`;
            }
            if (cleaned.length >= 7) {
                formatted += `-${cleaned.substring(6, 10)}`;
            }
        }

        return '+1 ' + formatted;
    }

}
